import React from 'react';
import './listamonit.css';
import {useState, useEffect} from 'react';
import api from '../../services/api.js';
import DataTable from 'react-data-table-component';

function ListaMonit(){

    let [dados,setdados] = useState([])

    const colunas = [

        { name:'Data',
          selector :row => row.Data, 
          sortable:true,
          width: "110px", 

        },
        {name:'Nº Ponto',
          selector :row => row.Numero,
          sortable:true,
          width: "100px",
         },
        { name:'Local',
            selector :row => row.Local,
            sortable:true,
            width: "400px", 
          },
        {name:'Tipo de Isca',
          selector :row => row.TipoIsca,
          width: "200px", 
        
        },
      { name:'Resultado',
      selector :row => row.Resultado,
      sortable:true,
      width: "500px",   },

 
      ]

     const paginationOptions={
        rowsPerPageText: 'Registros por página',
        rangeSeparatorText : 'de',
        selectAllRowsItem : true,
        selectAllRowsItemText :'Todos',
     } 
    async function CarregaPontos()
    {

        const user = localStorage.getItem("IdUsuario");
        const resultado = await api.get('/MonitNovo/?p='+user);

      setdados(resultado.data)       

    }

    useEffect(()=>{
          CarregaPontos()
    },[]
    );

    return (
    <>
            <DataTable className='tabela'
            columns= {colunas} 
            data={dados}
            pagination={true}
            paginationComponentOptions={paginationOptions}
            noDataComponent={"Nenhum registro encontrado !"}
            fixedHeader={true}
                />  
                  </> )
  
}

export default ListaMonit;